import script from "./ConciliacaoChargebackTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./ConciliacaoChargebackTabela.vue?vue&type=script&setup=true&lang=js"

import "./ConciliacaoChargebackTabela.vue?vue&type=style&index=0&id=7c9a106c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c9a106c"]])

export default __exports__